import * as firebase from 'firebase'
import { db } from '@/plugins/db'
import { firestoreAction } from 'vuexfire'
import {UserInterface} from "@/models/User";

export default {
    state:{
        users:[],
        userDetails: {}
    },
    actions:{
        bindUsers: firestoreAction(({ bindFirestoreRef }) => {
            // return the promise returned by `bindFirestoreRef`
            return bindFirestoreRef('users', db.collection('users').orderBy('createdAt', 'desc'))
        }),
        bindUserDetails: firestoreAction(({ bindFirestoreRef },id) => {
            // return the promise returned by `bindFirestoreRef`
            return bindFirestoreRef('userDetails', db.collection('userDetails').doc(id))
        }),

        createUser: firestoreAction(({commit}, payload) =>{
            commit('setLoading', true);
            firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password).then((user: firebase.auth.UserCredential) =>{
                commit('setLoading', false);
                const newUser: UserInterface = {
                    firstName: payload.firstName,
                    lastName: payload.lastName,
                    category: payload.category,
                    role: payload.role,
                    email: payload.email,
                    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                };
                // @ts-ignore
                return db.collection('users').doc(user.user.uid).set(newUser)
            }).catch(() => {
                commit('setLoading', false)
            })
        })
    }
}